/* tslint:disable no-switch-case-fall-through */
import { Action } from 'redux';
import { createSelector } from 'reselect';
import * as FutureActions from './futures.actions';
import { Future } from '@iv/model/instrument';

export interface FutureState {
  entities: any[];
}

const initialState: FutureState = {
  entities: []
};

export const FuturesReducer =
  function (state: FutureState = initialState, action: Action): FutureState {
    switch (action.type) {

      case FutureActions.ADD_FUTURES: {
        const futures = (<FutureActions.AddFutureAction>action).futures;
        const newFutures = [...futures];
        return {
          entities: newFutures
        };
      }

      default:
        return state;
    }
  };


export const getFutureState = (state): FutureState => {
  return state.futures;
};

export const getFuturesEntities = createSelector(
  getFutureState,
  (state: FutureState) => {
    return state.entities;
  }
);

export const getAllFutures = createSelector(
  getFuturesEntities,
  (entities: Future[]) => entities
);

